import { useEffect, useState } from "react";
import Config from "src/Constants/Config";
import CustomCenterContent from "src/Pages/CustomCenterContent";
import Page2 from "src/Component/Page2";

import { useSelector } from "react-redux";
import store from "src/Reducers/store";
import Skips from "src/Component/Skips";

const PageId = 2;
const NextPageId = PageId + 1;
const BackPageId = PageId - 1;

const DATA = () => {
  const baseImageBG = `${Config.BASE_URL}/images/BG/`;
  const [step, setStep] = useState(0);

  const currentPage = useSelector(() => store.getState().appReducer.currentPage);

  useEffect(() => {
    if (PageId === currentPage) setTimeout(() => setStep(1), 500);
    else setStep(0);

    return () => {
      setStep(0);
    };
  }, [currentPage]);

  return {
    title: "Tutorial",
    showHeader: true,
    fullScreen: true,
    bgImage: `${baseImageBG}BG_2.jpg`,
    children: (
      <CustomCenterContent
        pageId={PageId}
        showBack={step > 1}
        showNext={step > 1}
        backVisible={step > 6}
        nextVisible={step > 6}
        extraComponent={<Skips backPageId={BackPageId} nextPageId={NextPageId} />}
      >
        <Page2 step={step} setStep={setStep} />
      </CustomCenterContent>
    ),
  };
};

export default DATA;
